import React, { Dispatch, useEffect, useState } from "react"
import { Modal, Row, Col, Input, Radio, Button, message } from "antd";
import { useParams } from "react-router-dom";
import { createError } from '../../api/errors/errors';
import { useOlpnContext } from "./OlpnContext"

const ModalForceValidate = (props: {
  setModal: Dispatch<boolean>,
  modal: boolean
  setLoading: Dispatch<boolean>,
  setData: Dispatch<any>,
  setShowImage: Dispatch<any>,
  trayId: string | undefined,
  handleValidate,
  error,
  data
}) => {
  const { setModal, modal, setLoading, setData, setShowImage, trayId, data } = props
  const [error, setError] = useState<{ type: string, text: string } | undefined>(undefined)
  const [selected, setSelected] = useState<number | undefined>(undefined)
  const [isInput, setInput] = useState<boolean>(false)
  const { bpId, sku } = useParams()
  const { Olpn } = useOlpnContext()

  useEffect(() => {
    if (modal) {
      const data = sessionStorage.getItem("error")
      if (data)
        setError(JSON.parse(data))
    }
  }, [modal])

  const findBracelet = (list: any) => {
    if (!list && !list[0]) return undefined
    for (let i = 0; i < list[0]?.Bracelets?.length; i++) {
      if (list[0]?.Bracelets[i].sku && list[0]?.Bracelets[i].barcode3)
        return list[0].Bracelets[i]
    }
    return undefined
  }

  const handleOk = async () => {
    if (trayId?.length === 0) return message.error("L'identifiant de plateau ne peut pas etre vide")
    setLoading(true)
    if (bpId && Olpn && trayId) {
      let bracelet = findBracelet(data)
      // delete bracelet.bbox
      if (!selected) {
        let tmp = data[0]?.Bracelets?.length
        const newList = new Array(tmp).fill(bracelet)
        await props.handleValidate(newList, true)
      } else {
        const newList = new Array(selected).fill(bracelet)
        await props.handleValidate(newList, true)
      }
    }
    setLoading(false)
    setData(undefined)
    setShowImage(undefined)
    setModal(false)
  }

  const handleCancel = () => {
    setModal(false)
  }

  return (
    <Modal title={"Forcer la validation du plateau"} open={modal}
      onCancel={handleCancel}
      centered
      footer={null}
    >
      <div style={{ textAlign: 'center' }}>{error?.text}</div>
      <Row style={{ alignItems: 'center', textAlign: 'center', paddingTop: "2rem" }}>
        {error?.type === 'count' &&
          <>
            {!isInput ?
              <>
                <Col xs={8}>
                  <Radio.Button checked={selected === 5} value={5} onClick={(e) => setSelected(5)} >5</Radio.Button>
                </Col>
                <Col xs={8}>
                  <Radio.Button checked={selected === 10} value={10} onClick={(e) => setSelected(10)} >10</Radio.Button>
                </Col>
                <Col xs={8}>
                  <Radio.Button checked={selected === 15} value={15} onClick={(e) => setSelected(15)}>15</Radio.Button>
                </Col>
              </>
              :
              <>
                <Col xs={16}>
                  <Input type="number" value={selected} onChange={(e) => setSelected(Number(e.target.value))} allowClear />
                </Col>
              </>
            }
            <Col xs={8}>
              <Button onClick={() => { setInput(!isInput); setSelected(undefined) }}>{isInput ? "Annuler" : "Autre"}</Button>
            </Col>
          </>
        }
        <Col xs={12} style={{ paddingTop: "1rem" }}>
          <Button onClick={() => { props.setModal(false) }} size="large">Annuler</Button>
        </Col>
        <Col xs={12} style={{ paddingTop: "1rem" }}>
          <Button onClick={() => { handleOk() }} style={{ backgroundColor: "#10b981", color: 'white' }} size="large">Confirmer</Button>
        </Col>
      </Row>
    </Modal>
  )
}

export default ModalForceValidate;